import { useEffect, useRef, useState } from "react";
import "../../../styles/components/management/Chat/InsertFieldButton.css";

export default function InsertFieldButton({ booking = {}, onInsert = () => {} }) {
  const [showFields, setShowFields] = useState(false);
  const sortedKeys = Object.keys(booking).sort();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        showFields &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !e.target.closest(".insert-field-button")
      ) {
        setShowFields(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === "Escape") setShowFields(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [showFields]);

  return (
    <div style={{ position: "relative" }}>
      <button
        className="insert-field-button"
        onClick={() => {
          console.log("[InsertFieldButton] Toggle click. Fields open:", !showFields);
          setShowFields((prev) => !prev);
        }}
        title="Insert booking field"
      >
        ＋
      </button>

      {showFields && (
        <ul className="booking-fields-dropdown" ref={dropdownRef}>
          {sortedKeys.map((key) => (
            <li
              key={key}
              onMouseDown={(e) => {
                e.preventDefault();
                console.log(`[InsertFieldButton] Inserting: ${key} =`, booking[key]);
                onInsert(booking[key] ?? "");
                setShowFields(false);
              }}
            >
              <strong>{key.replace(/_/g, " ")}:</strong> {booking[key] ?? "—"}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
